import { defineMessages } from 'react-intl';

export const messages: {
	updatedText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	updatedText: {
		id: 'conversation-assistant-ui-components.updated-text',
		defaultMessage: 'Updated {timeAgo}',
		description:
			"When the page was last modified. 'timeAgo' is of the form `1 hour ago` or a date `September 15, 2020` (in English)",
	},
});
